import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfCategory } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';

const initialValuesOfCategory = {
	ID: '',
	DESCRICAO: '',
	ORGAO: '',
};

export const useListCategoriesController = () => {
	const [categoriesData, setCategoriesData] = useState<ModelOfCategory[]>([]);
	const [selectedCategory, setSelectedCategory] = useState<ModelOfCategory>(initialValuesOfCategory);
	const [loading, setLoading] = useState(true);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);

	const { userAgencyId } = useAuth();
	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo Obrigatório'),
	});

	const getCategories = async () => {
		api.get(`categorys/${userAgencyId}`)
			.then(response => {
				const data = response.data;
				setCategoriesData(data);
				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.statusText);
				setLoading(false);
			});
	};

	const removeCategory = (category: ModelOfCategory) => {
		setLoading(true);
		api.delete(`categorys/${category.ID}`)
			.then(() => {
				getCategories();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'A categoria foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getCategories();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editCategory = (category: ModelOfCategory) => {
		setLoading(true);

		const editedCategory: ModelOfCategory = {
			...category,
			ORGAO: userAgencyId,
		};

		api.put(`categorys/${selectedCategory?.ID}`, editedCategory)
			.then(() => {
				getCategories();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'A categoria foi editada com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getCategories();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getCategories();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userAgencyId]);

	const openDeleteDialog = (category: ModelOfCategory) => {
		setDeleteDialog(true);
		setSelectedCategory(category);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (category: ModelOfCategory) => {
		setEditDialog(true);
		setSelectedCategory(category);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfCategory>({
		initialValues: {
			ORGAO: '',
			DESCRICAO: '',
		},
		onSubmit: async values => await editCategory(values),
		validationSchema,
	});

	return {
		getCategoryListController: {
			formik,
			categoriesData,
			selectedCategory,
			loading,
			deleteDialog,
			editDialog,
			toast,
		},
		handleCategoryListController: {
			removeCategory,
			editCategory,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
		},
	};
};
